import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'mode-google-sheet-sync-failure-toast',
  standalone: true,
  imports: [SharedUtilToastModule],
  animations: [ToastAnimation],
  templateUrl: './google-sheet-sync-failure-toast.component.html',
  styleUrls: ['./google-sheet-sync-failure-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleSheetSyncFailureToastComponent extends Toast {}
